import { ActionHandler } from 'action-handler';

const stateProp = 'pendingAppInstallStatus';

export const updatePendingFromInstalledReducer = (state, installedApps) => {
  const pending = state[stateProp];
  const newPending = {};
  for (const appId in pending) {
    const pendingApp = pending[appId];
    const installedApp = installedApps[appId];

    const hasNotChanged =
      installedApp &&
      pendingApp.installStatus === installedApp.installStatus &&
      pendingApp.selected === installedApp.selected &&
      pendingApp.active === installedApp.active;

    // If the app's install status has changed, it isn't pending so drop it
    if (hasNotChanged) {
      newPending[appId] = pendingApp.installStatus;
    }
  }

  return {
    [stateProp]: newPending
  };
};

export default new ActionHandler({
  name: 'set_pending_app_install_status',
  stateProp,
  defaultState: {
    [stateProp]: {}
  },
  handler: (app) => ({
    appId: app.id,
    installStatus: app.installStatus,
    selected: app.selected,
    active: app.active
  }),
  reduce: (state, { appId, installStatus, selected, active }) => ({
    [stateProp]: {
      ...state[stateProp],
      [appId]: {
        installStatus, // existing app install status
        selected,
        active
      }
    }
  })
});
